import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterExercises'
})

/**
 * Searches text of exercise names and returns any that contain the search text
 * @param {any[]} exercises - collection of Exercises
 * @param {string} searchText - text to search by
 * @returns {any[]} - filtered collection of Exercises
 */
@Injectable()
export class FilterExercisesPipe implements PipeTransform {
  transform(exercises: any[], searchText: string): any {
    if (searchText === undefined) { return exercises; }

    return exercises.filter(exercise => {
      return (exercise.name).toLowerCase().indexOf(searchText.toLowerCase()) > -1;
    });
  }
}
